import { defineComponent as _defineComponent } from 'vue'
import { computed, unref } from 'vue';
    import CheckBoxInputListWithOneSelect from '@fr/vue/components/inputs/CheckBoxInputListWithOneSelect.vue';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import HintTooltip from '@ve/components/hintTooltip/desktop/HintTooltip.vue';
    import FilterListItem from '@ve/components/searchFilters/filterList/desktop/FilterListItem.vue';
    import TextCommon from '@ve/components/inputs/TextCommon.vue';
    import useVueProxy from '@ve/services/useVueProxy';
    import { useState } from 'vuex-composition-helpers';
    import { IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
    import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';
    import useMealsReference from '@ve/components/filters/mealsFilter/common/useMealsReference';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MealsFilterList',
  emits: ["change"],
  setup(__props, { emit }: { emit: ({(e: 'change', value: IMapForFiltersSerpState['meals']): void;}), expose: any, slots: any, attrs: any }) {

    
    const { $root } = useVueProxy();
    const {
        meals,
    } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['meals']);

    const selectedMeals = computed({
        get: () => unref(meals),
        set: (value) => {
            emit('change', value);
            $root?.$emit('meals-filter-changed', value);
        },
    });

    const {
        allMealsChecked,
        mealsReference,
    } = useMealsReference({
        selectedMeals,
        storeName: nameFilterSerpStore,
    });

return { __sfc: true,emit, $root, meals, selectedMeals, allMealsChecked, mealsReference, CheckBoxInputListWithOneSelect, CheckBoxInput, HintTooltip, FilterListItem, TextCommon }
}

})